/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import produce from 'immer';
import { CHANGE_USERNAME, ON_CALL_UPLOAD, LOADER_STATUS, RESPONSE_MESSAGE, PROFILE_DATA, INVOICE_DATA, UPDATE_MODULE,SET_RADIO_VAL} from './constants';

// The initial state of the App
export const initialState = {
  username: '',
  uploadData: '',
  loaderStatus: false,
  msg: '',
  status: false,
  InvoiceDetailData: {},
  profileData:[],
  error: 0,
  module: "eInv",
  radioVal: true
};

/* eslint-disable default-case, no-param-reassign */
const invoiceReducer = (state = initialState, action) =>{
    switch (action.type) {
      case CHANGE_USERNAME:
        return {
          ...state,
          username:action.username.replace(/@/gi, '')
        }
      case ON_CALL_UPLOAD:
        return {
          ...state,
          uploadData:action.uploadData
        }
      case PROFILE_DATA:
        return {
          ...state,
          profileData:action.profileData
        }
      case LOADER_STATUS:
        return {
          ...state,
          loaderStatus:action.loaderStatus
        }
      case RESPONSE_MESSAGE:
        return {
          ...state,
          msg:action.msg,
          status:action.status,
          error:action.error
        }
      case INVOICE_DATA:
        return {
          ...state,
          InvoiceDetailData:action.InvoiceDetailData
        }
      case UPDATE_MODULE:
        return {
          ...state,
          module:action.module
        }
      case SET_RADIO_VAL:
        return {
          ...state,
          radioVal:action.radioVal
        }
        default:
          return state;
    }
  };

export default invoiceReducer;
